module.exports = __webpack_public_path__ + "static/media/picture-photo-image-svgrepo-com.7254e76b.svg";